import { Alert } from '@blueprintjs/core';
import { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import proyectosService from '../../services/proyectos.service';
import { AppContext } from '../../utils/context/app.context';
import { toast } from 'react-toastify';
import { AuthContext } from '../../utils/context/auth.context.ts';
import FormComponent from '../../utils/components/form.component.js';
import Vars from "../../utils/json/variables.json"
import documentosService from '../../services/documentos.service.js';

export default function ProyectoEntregables(props) {
    const { proyecto, canEdit, get } = props;
    const { t } = useTranslation();
    const appContext = useContext(AppContext);
    const authContext = useContext(AuthContext);
    const [alert, setAlert] = useState(false)
    const [isLoading, setLoading] = useState(false)
    const [isADM] = useState(authContext.isSAD() || authContext.isADM())

    async function remove_document(id, form) {
        if (authContext.verify({ pathname: "/documentos" }, "DELETE")) {
            toast.info(t('actions.procesing'))
            return documentosService.delete(id)
                .then(res => {
                    if (res.data) {
                        toast.dismiss();
                        toast.success(t('actions.deleted'));
                    }
                })
                .catch(error => {
                    appContext.errorHandler(error, toast, t);
                })
                .finally(() => get(proyecto))
        } else {
            toast.warning(t('auth.nopermit'))
        }

    }

    function onDeleteFile(file, name) {
        if (authContext.verify({ pathname: '/documentos' }, "DELETE")) {
            toast.info(t('actions.procesing'));
            let document = proyecto.documentos.find(d => d.url === file);
            if (!document) return toast.warning(t('auth.nopermit'))
            documentosService.delete_file(file, document.id, 'documento')
                .then(res => {
                    if (res.data) {
                        toast.dismiss();
                        toast.success(t('actions.deleted'));
                    }
                })
                .catch(error => {
                    appContext.errorHandler(error, toast, t);
                })
                .finally(() => {
                    get(proyecto);
                })
        } else {
            toast.warning(t('auth.nopermit'))
        }
    }

    function remove(id) {
        if (authContext.verify({ pathname: '/documentos' }, "DELETE")) {
            toast.info(t('actions.procesing'), { autoClose: false, theme: "light", })
            proyectosService.delete(id)
                .then(res => {
                    if (res.data) {
                        toast.dismiss();
                        toast.success(t('actions.deleted'));
                    }
                })
                .catch(error => appContext.errorHandler(error, toast, t))
                .finally(() => {
                    get(proyecto);
                })
        } else {
            toast.warning(t('auth.nopermit'))
        }

    }

    function update(form, id) {
        if (authContext.verify({ pathname: "/documentos" }, "PUT")) {
            setLoading(true);
            toast.info(t('actions.procesing'));
            documentosService.update(form, id)
                .then(res => {
                    if (res.data) {
                        toast.dismiss();
                        toast.success(t('actions.edited'));
                    }
                })
                .catch(error => appContext.errorHandler(error, toast, t))
                .finally(() => {
                    get(proyecto);
                    setLoading(false);
                })
        } else {
            toast.warning(t('auth.nopermit'))
        }
    }

    function getDocName(props, name) {
        let docDesc = props.groupData ? (props.groupData.descripcion || '') : '';
        if (docDesc) return name + "_" + docDesc || '';
        return name;
    }

    function getExt(i) {
        return ((i.groupData?.url || '').split('.')[1] || '').toUpperCase();
    }

    const FORM = (i) => [
        {
            title: t('entregables.form.section_1'),
            multiple: true,
            fixed: !canEdit,
            hide: !isADM,
            defaultValues: i?.documentos.filter(d => d.categoria === 'A'),
            name: 'documentos_adn',
            deleteApi: remove_document,
            deleteAllow: isADM ? authContext.verify({ pathname: "/documentos" }, "DELETE") : false,
            inputs: [
                [
                    { id: "desc_adm", index: 'descripcion', title: t('entregables.form.desc'), placeholder: t('entregables.form.desc'), icon: "document", },
                    { id: "url_adm", index: 'url', filenameFn: (d) => getDocName(d, t('entregables.form.file_adm')), title: t('entregables.form.url'), placeholder: t('entregables.form.url'), icon: "folder-open", type: 'file', onDelete: onDeleteFile },
                    { id: "ext_adm", defaultValue: getExt, index: 'ext', title: t('entregables.form.ext'), placeholder: t('entregables.form.ext'), icon: "tag", read: true, },
                    { id: "categoria_adm", index: 'categoria', defaultValue: i?.categoria || "A", title: t('entregables.form.categoria'), placeholder: t('entregables.form.categoria'), icon: "tag", type: "select", list: Vars.document_category.map(i => ({ value: i, text: t('general.document_category.' + i) })), read: true },
                ],
            ]
        },
        {
            title: t('entregables.form.section_2'),
            multiple: true,
            fixed: !canEdit,
            hide: false,
            defaultValues: i?.documentos.filter(d => d.categoria === 'T'),
            name: 'documentos_tec',
            deleteApi: remove_document,
            deleteAllow: isADM ? authContext.verify({ pathname: "/documentos" }, "DELETE") : false,
            background: "#e9d9aaff",
            inputs: [
                [
                    { id: "desc_tec", index: 'descripcion', title: t('entregables.form.desc'), placeholder: t('entregables.form.desc'), icon: "document", read: proyecto.director },
                    { id: "url_tec", index: 'url', filenameFn: (d) => getDocName(d, t('entregables.form.file_tec')), title: t('entregables.form.url'), placeholder: t('entregables.form.url'), icon: "folder-open", type: 'file', onDelete: onDeleteFile, disabled: !canEdit },
                    { id: "ext_tec", defaultValue: getExt, index: 'ext', title: t('entregables.form.ext'), placeholder: t('entregables.form.ext'), icon: "tag", read: true, },
                    { id: "categoria_tec", index: 'categoria', defaultValue: i?.categoria || "T", title: t('entregables.form.categoria'), placeholder: t('entregables.form.categoria'), icon: "tag", type: "select", list: Vars.document_category.map(i => ({ value: i, text: t('general.document_category.' + i) })), read: true },
                ],
            ]
        },
        {
            title: t('entregables.form.section_3'),
            multiple: true,
            fixed: !canEdit,
            hide: false,
            defaultValues: i?.documentos.filter(d => d.categoria === 'E'),
            name: 'documentos_entre',
            deleteApi: remove_document,
            deleteAllow: isADM ? authContext.verify({ pathname: "/documentos" }, "DELETE") : false,
            inputs: [
                [
                    { id: "desc_ent", index: 'descripcion', title: t('entregables.form.desc'), placeholder: t('entregables.form.desc'), icon: "document", read: proyecto.director },
                    { id: "url_ent", index: 'url', filenameFn: (d) => getDocName(d, t('entregables.form.file_ent')), title: t('entregables.form.url'), placeholder: t('entregables.form.url'), icon: "folder-open", type: 'file', onDelete: onDeleteFile, disabled: !canEdit },
                    { id: "ext_ent", defaultValue: getExt, index: 'ext', title: t('entregables.form.ext'), placeholder: t('entregables.form.ext'), icon: "tag", read: true, },
                    { id: "categoria_ent", index: 'categoria', defaultValue: i?.categoria || "E", title: t('entregables.form.categoria'), placeholder: t('entregables.form.categoria'), icon: "tag", type: "select", list: Vars.document_category.map(i => ({ value: i, text: t('general.document_category.' + i) })), read: true },
                ],
            ]
        },
    ]


    const BODY = (i) => <FormComponent
        actions={{
            primary: canEdit ? { icon: "edit", text: t('actions.edit'), intent: "warning" } : null,
            secondary: null
        }}
        onSecondary={null}
        onSubmit={(data) => {
            let documenos = [...i.documentos];
            let newDocs = [];

            documenos.map(od => {
                data.documentos_adn.map(d => {
                    if (od.id === d.id) newDocs.push({ ...od, ...d });
                })

                data.documentos_tec.map(d => {
                    if (od.id === d.id) newDocs.push({ ...od, ...d });
                })

                data.documentos_entre.map(d => {
                    if (od.id === d.id) newDocs.push({ ...od, ...d });
                })
            })

            data.documentos_adn.map(d => {
                if (!d.id) newDocs.push(d);
            })

            data.documentos_tec.map(d => {
                if (!d.id) newDocs.push(d);
            })

            data.documentos_entre.map(d => {
                if (!d.id) newDocs.push(d);
            })

            i.documentos = [...newDocs];

            update(i, i.id);
        }}
        groups={FORM(i)}
        dataRef={i}
    />

    const LOADING = <div class="text-center mt-5 pt-5">
        <div class="spinner-border" role="status">
        </div>
    </div>


    const ALERT = () => <Alert
        cancelButtonText={t('actions.cancel')}
        confirmButtonText={t('actions.delete')}
        canEscapeKeyCancel={true}
        canOutsideClickCancel={true}
        icon={'trash'}
        intent={'danger'}
        isOpen={alert}
        loading={null}
        onCancel={() => {
            setAlert(false);
        }}
        onConfirm={() => {
            setAlert(false);
            remove(proyecto?.id);
        }}
    >
        <p>{t('actions.bodyDelete').replace('%VAR%', proyecto?.nombre)}</p>

    </Alert>

    return (<>
        {isLoading ? LOADING : proyecto ? <>
            {ALERT()}
            {BODY(proyecto)}
        </> : null}
    </>
    );
}
